import React, { useState, useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import blue_email from "../assets/images/blue_email.svg";
import { AppContext } from "../contaxt/AppContext";
import ShieldQuestion from "../assets/images/ShieldQuestion.svg";
import AccessTime from "../assets/images/AccessTime.svg";
import nextplan from "../assets/images/nextplan.svg";
import { useNavigate } from "react-router-dom";
import arrowRight from "../assets/images/arrow-right.svg";
import Frame1 from "../assets/images/icon011.svg";
import saveIcon from "../assets/images/Save.svg";
import CheckCircleIcon from "../assets/images/checkGrey.svg";
import CheckCircleActvIcon from "../assets/images/checkGreen.svg";
import { useDispatch, useSelector } from "react-redux";
import { updateData } from "../redux/roundtoSlice";
import LYWOLogoSmall from "../assets/images/LYWOLogoSmall.svg";
import {
  PostCallWithErrorResponse,
  postWithAuthCallWithErrorResponse,
  simpleGetCall,
} from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import closeIcon from "../assets/images/closeIcon.svg";
import VerifiedUserWhite from "../assets/images/VerifiedUserWhite.svg";
import questionmark from "../assets/images/Questionmark.svg";
import vector from "../assets/images/Vector1.svg";
import Stacked from "../assets/images/Trending up1.svg";
import Group from "../assets/images/Lightbulb outline1.svg";
import Frame from "../assets/images/Rocket launch1.svg";
import File from "../assets/images/Summarize1.svg";

export default function Lywobehaviorexit() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false);
  const currentStep = 2;
  const rounddata = useSelector((state) => state.roundData);
  const [showRedirectModal, setShowRedirectModal] = useState(false);
  const [isDataLoad, setIsDataLoad] = useState(true);
  const { setIsNormal, setUniqueCode } = useContext(AppContext);

  const getProgressWidth = () => {
    if (currentStep === 1) return "33%";
    if (currentStep === 2) return "66%";
    if (currentStep === 3) return "100%";
  };

  const [showExitModal, setShowExitModal] = useState(false);

  const editProfile = () => {
    dispatch(updateData({ field: "isEditDetails", value: true }));
    navigate("/JobApplicationProcess", { state: { fromOtherPage: true } });
  };
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile(); // initial check
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const getAssementDetails = async (code = '', userId = '') => {

    setIsDataLoad(false)

    PostCallWithErrorResponse(ApiConfig.GET_QUIZE_QUESTIONS, {
      jobcode: code ? code : rounddata?.code,
      userId: userId ? userId : rounddata.userId,
    }).then((res) => {
      if (res?.json?.succeded) {
        dispatch(
          updateData({
            field: "questions",
            value: res?.json?.response?.questions,
          })
        );
        dispatch(
          updateData({
            field: "duration",
            value: res?.json?.response?.duration,
          })
        );
        dispatch(
          updateData({ field: "quizId", value: res?.json?.response?.quizId })
        );

        setIsDataLoad(true);
      }

    })

  }

  useEffect(() => {

    if (rounddata.isSaveQuiz) {
      dispatch(updateData({ field: 'isQuiz', value: true }))
      getAssementDetails()
    }

  }, [])



  const quizSteps = [
    {
      title: "Increase the Impact of Your Application",
      subtitle: "A Good Score can help round out any gap",
      icon: vector,
    },
    {
      title: "Show genuine interest in the Opportunity",
      subtitle:
        "Participating in all screening steps showcases your interest in the role",
      icon: Frame,
    },
    {
      title: "Be better prepared for facing the Next Steps",
      subtitle:
        "The areas tested will give an insight into how the next steps will be",
      icon: Stacked,
    },
    {
      title: "One-Time Attempt",
      subtitle: "No pause or save — make sure you’re ready before you begin.",
      icon: Frame1,
      variant: "warning",
    },
  ];

  return (
    <>
      <div className="paGeWrap m-botm">
        <div className="paGeWrap-pdg">
          <div className="container colCntR">
            <h3>Dear {rounddata?.userName}</h3>
            <h4>Great job! You’ve finished the Behavioral Assessment.</h4>

            <div className="col-12 col-md-10 col-lg-8 emailNotifiTxt mobBgWrap">
              <p>
                <img src={blue_email} className="blueEmailIcon mb-1" />
                We will send you an update on{" "}
                <span className="eMailaDrs">{rounddata?.userEmail}</span>
              </p>
            </div>

            <div className="col-12 col-md-10 col-lg-8 mobBgWrap1">
              <div className="progressbarWrap">
                <div className="progressBarContainer">
                  <div
                    className="progressFill"
                    style={{ width: getProgressWidth() }}
                  ></div>
                </div>

                <div className="mileStoneTxtnew">

                  <div className="milstnTxtImgnew">
                    <img src={CheckCircleActvIcon} className="checkIcon" />
                    <p className="mileStoneActv"> Info</p>
                  </div>
                  <div className="milstnTxtImgnew">
                    <img src={CheckCircleActvIcon} className="checkIcon" />
                    <p className="mileStoneActv">Behavior</p>
                  </div>
                  <div className="milstnTxtImgnew">
                    <img src={CheckCircleIcon} className="checkIcon" />
                    <p>MCQ</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-10 col-lg-8">
              <div className="behavr-box-wrap">
                <div className="behavr-txt-box pb-0">
                  <h2 className="next-step-lywoexit mb-0 text-center">
                    The Next Step is a Multiple Choice Quiz
                  </h2>
                </div>

                <div className="ARW-sec-flshScrn pt-0">
                  <div
                    className="pers-testexit "
                    style={{ marginBottom: "8px" }}
                  >
                    {/* <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <p style={{ display: "contents" }}>
                        Why do we conduct a Multiple Choice Quiz
                      </p>
                      <img src={questionmark} width={16} height={16} />
                    </div> */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                      className="smallText"
                    >
                      <p style={{ display: "contents" }}>
                        {isMobile
                          ? "Why  do we conduct MCQ"
                          : "Why do we conduct the MCQ "}
                      </p>
                      <img src={questionmark} width={16} height={16} alt="?" />
                    </div>
                  </div>

                  {/* {quizSteps.map((step, index) => (
                    <div className={`techQzboxexit ${step.variant === 'warning' ? 'warning' : ''}`} key={index}>
                      <div className="icon-wrapperexit">
                        <img src={step.icon} alt="icon" />
                      </div>
                      <div className="text-wrapper">
                        <p className={`info-title ${step.variant === 'warning' ? 'text-red' : ''}`}>{step.title}</p>
                        <p className="info-subtitle">{step.subtitle}</p>
                      </div>
                    </div>
                  ))} */}
                  {quizSteps.map((step, index) => (
                    <div
                      className={`d-flex align-items-center techQzboxexit ${step.variant ? `variant-${step.variant}` : ""
                        }`}
                      key={index}
                      style={{ backgroundColor: step.variant }}
                    >
                      <div
                        className="icon-wrapperexit"
                        style={{ backgroundColor: step.smallbox }}
                      >
                        <img
                          className="img-tic-media"
                          src={step.icon}
                          alt="icon"
                          width={16}
                          height={16}
                        />
                      </div>
                      <div className="text-wrapper">
                        <p
                          className="info-title"
                          style={{ marginBottom: "0px" }}
                        >
                          {step.title}
                        </p>
                        <p
                          className="info-subtitle"
                          style={{ marginBottom: "0px" }}
                        >
                          {step.subtitle}
                        </p>
                      </div>
                    </div>
                  ))}

                </div>
                <div className='neWbTnAreaWrap'>
                  <div className="btnLywo1" onClick={() => {
                    if (isDataLoad) {
                      if (rounddata?.isSaveQuiz) {
                        navigate('/Questionanswer1')
                      } else {
                        setShowRedirectModal(true)
                      }
                    }


                  }}>
                    <p>Let’s Start the Test</p>
                    <img src={arrowRight} className="mobIcon" alt="start" />
                  </div>

                  <div
                    className="btnLywo2exttt"
                    onClick={() => setShowExitModal(true)}
                  >
                    <p>Return Later to complete</p>
                    <img src={saveIcon} className="mobIcon" alt="save" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showRedirectModal && (
          <div className="mcq-sbmt-modal-overlay1">

            <div className="mcq-sbmt-modal-content1 center-content">
              <div
                className="modal-close1"
                onClick={() => setShowRedirectModal(false)}
              >
                <img src={closeIcon} alt="Close" />
              </div>

              <h4 className="redirect-title1">
                You Are Leaving{" "}
                <span className="bold-text">
                  <img src={LYWOLogoSmall} />
                </span>
              </h4>
              <p className="redirect-subtitle1">
                MCQ will be conducted via Google Forms
              </p>

              <div className="warning-msg1">
                {/* <img src={Frame1} alt="warn" /> */}
                <span className="">
                  Provide the same Email on the form as you have used in this application !
                </span>

              </div>
              <div className="center-btn-wrapper mb-3 mt-3">
                <div
                  className="btnLywo12"
                  onClick={() => {
                    // window.open(rounddata?.externalQuizLink, "_self");
                    window.open(rounddata?.externalQuizLink, "_blank");

                    setShowRedirectModal(true);
                  }}
                >
                  <p>Launch The test</p>
                  <img src={arrowRight} className="mobIcon" alt="start" />
                </div>
              </div>

              {/* <button className="launch-btn1" onClick={() => window.open("https://docs.google.com/forms/your-form-link", "_blank")}>
           
          </button> */}

              <p className="quiz-link-note1" style={{ marginBottom: "0px" }}>
                If you’re not redirected after clicking on the button, click the link below:
              </p>
              <a className="quiz-link link-qizzz" href={rounddata?.externalQuizLink} target="_blank" rel="noreferrer">
                {rounddata?.externalQuizLink}h
              </a>
            </div>
          </div>
        )}
        {showExitModal && (
          <div className="mcq-sbmt-modal-overlay">
            <div className="mcq-sbmt-modal-content">
              <div className="modal-top-close-btn">
                <img
                  src={closeIcon}
                  className="mobIcon"
                  alt=""
                  onClick={() => setShowExitModal(false)}
                />
              </div>

              <div className="mcq-sbmt-modal-header">
                <h4>Your progress has been saved</h4>
              </div>
              <div className="mcq-sccs-txt">
                <p>You can return anytime to complete the test.</p>
              </div>

              <div
                className="mcq-sbmt-exit-btn"
                onClick={() => {
                  setShowExitModal(false);
                  navigate("/Lywocode");
                }}
              >
                <p>Save & Exit</p>
              </div>
            </div>

          </div>

        )
        }
        <div className="dsktp-footer">


          <div className="dsktp-footer-right">
            {/* <div className='lang-dsktp'>
                 <img src={languageIcon} className="mobIcon" alt="Select language" />
                 <p>Behavior test Language</p>
                 <div className='langbox-dsktp' onClick={() => setShowLanguagePopup(true)}>
                     <p>English</p>
                     <img src={arrowUp} className="mobIcon" alt="Select language" />
                 </div>
             </div> */}

            <button
              className="comp-savebtn"
              onClick={editProfile
              }
              style={{ width: "120px", padding: "8px 14px", height: "40px" }}
            >
              Edit Profile
            </button>
          </div>
          <div className="dsktp-footer-left">
            <div className="dsktp-footerjob-info">

              <div className='v-u-jobcode'>
                <h6>JOB-2024-001</h6>
                <p>This application Process is Managed by <span>LYWO</span></p>
              </div>
              <div className='v-u-bg'>
                <img src={VerifiedUserWhite} className="vu-icon" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
